import payload_plugin_qLmFnukI99 from "/var/www/lottobox-agent/node_modules/@pinia/nuxt/dist/runtime/payload-plugin.js";
import revive_payload_client_4sVQNw7RlN from "/var/www/lottobox-agent/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/var/www/lottobox-agent/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/var/www/lottobox-agent/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/var/www/lottobox-agent/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/var/www/lottobox-agent/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/var/www/lottobox-agent/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/var/www/lottobox-agent/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/var/www/lottobox-agent/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/var/www/lottobox-agent/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/var/www/lottobox-agent/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import switch_locale_path_ssr_5csfIgkrBP from "/var/www/lottobox-agent/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/var/www/lottobox-agent/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import bindAdminCookie_client_jUMCvWYshf from "/var/www/lottobox-agent/plugins/bindAdminCookie.client.ts";
import axios_client_cuW4S0F533 from "/var/www/lottobox-agent/plugins/axios.client.ts";
import antd_client_spmiCi8vwb from "/var/www/lottobox-agent/plugins/antd.client.ts";
import error_client_aUA8HQSx65 from "/var/www/lottobox-agent/plugins/error.client.ts";
import axios_QMFgzss1s4 from "/var/www/lottobox-agent/plugins/axios.ts";
import toast_client_9z8IIRO0Dx from "/var/www/lottobox-agent/plugins/toast.client.ts";
export default [
  payload_plugin_qLmFnukI99,
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  bindAdminCookie_client_jUMCvWYshf,
  axios_client_cuW4S0F533,
  antd_client_spmiCi8vwb,
  error_client_aUA8HQSx65,
  axios_QMFgzss1s4,
  toast_client_9z8IIRO0Dx
]